import Cookies from 'js-cookie';
import router, { resetRouter } from '@/router';
import { show } from "@/api/common.js";

let state = {
    userinfo: Cookies.get('userinfo') ? JSON.parse(Cookies.get('userinfo')) : {}
};

const mutations = {
    SET_INFO: (state, info) => {
        Object.assign(state.userinfo, info, state.userinfo);
        Cookies.set('userinfo', state.userinfo);
        console.log('set userinfo', state.userinfo);
    },
    LOGOUT: (state) => {
        state.userinfo = {};
        Cookies.set('userinfo', {});
    }
};

const actions = {
    setInfo({ commit }, userInfo) {
        return new Promise((resolve, reject) => {
            commit('SET_INFO', userInfo);
            resolve();
        });
    },
    getInfo({ commit, state }) {
        return new Promise((resolve, reject) => {
            if (state.userinfo.id) {
                show('webuser', state.userinfo.id).then(res => {
                    commit('SET_INFO', res.data);
                    resolve({
                        ...res.data
                    });
                });
            }
        });
    },
    logout({ commit, state }) {
        return new Promise((resolve, reject) => {
            commit('LOGOUT', {});
            resolve();
        })
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
}